<template>
  <v-group
    ref="group"
    :config="groupConfig"
    @wheel="onWheel"
    @click="onClickGroup"
    @dbltap="onDblClickImage"
    @dblclick="onDblClickImage"
    @transformend="onUpdatePosition"
    @transform="onTransform"
    @dragend="onUpdatePosition"
    @mouseover="onMouseOver"
    @mouseout="onMouseOut">

    <template v-if="isComplete">

      <v-image
        ref="image"
        :config="imageConfig /* ALTERNATIV: { ...imageConfig, image: image} */"
        v-if="goalConfig.showImage"
        />

      <v-text
        ref="headline"
        v-if="stageSettings.showAllHeadlines && goalConfig.showHeadline"
        :config="headlineTextConfig"
        />

      <!-- todo use v-icon -->
      <!--
      <v-path
        :config="editButtonIcon"
        v-if="isSelected"
        @click="editIconClick"
        @tap="editIconClick" />
      -->
      <!--
        :offsetX="editIconPosition.offsetX"
        :offsetY="editIconPosition.offsetY"
      -->
      <v-icon
        :x="editIconPosition.x"
        :y="editIconPosition.y"
        v-if="isSelected"
        @click="editIconClick"
        buttonText="Edit goal"
        iconName="editGoalIcon"
        iconType="edit" />

      <v-icon
        :x="10"
        :y="10"
        v-if="isSelected"
        @click="addCommitmentIconClick"
        buttonText="Add commitment"
        iconName="addCommitmentIcon"
        iconType="add" />

<!--
      <v-text
        :config="headlineTextConfig"
        v-if="stageSettings.showAllHeadlines && goalConfig.showHeadline"
        @dragmove="/* dragHeadline */"
        @transform="scaleHeadline"
        @mouseover="/* handleStageMouseDown */"
        @dblclick="showGoalUpdateForm(goalConfig.goalId)"
        @dblTap="showGoalUpdateForm(goalConfig.goalId)" /> -->
      <!-- <portal to="visionboard-debug">PORTAL {{goal_id}}: {{goal}}</portal> -->

      <template v-if="stageSettings.showAllCommitments && goalConfig.showCommitments">
        <v-group
          v-for="commitmentConfig in commitmentConfigList"
          v-if="commitmentConfig.showCommitment"
          :key="commitmentConfig.$id"
          :config="commitmentConfig.group"
          @mouseover="onMouseOverCommitment($event, commitmentConfig.$id)"
          @mouseout="onMouseOutCommitment($event, commitmentConfig.$id)">

          <!-- <v-text
            :config="commitmentConfig.configText"
            @dragmove="/* dragCommitment($event, goal_id, commitmentConfig.$id) */"
            @mouseover="/* handleStageMouseDown */" /> -->
          <v-text :config="Object.assign({}, commitmentConfig.configText, {
              /* The reason why me merge here, is that we don't want to trigger
                 a complete evaluation of the configText property (which has a
                 lot of dependencies) just because the highlighting has changed.
                 This would probably also be a good reason to not pack everything
                 into a 'config' variable in the first place, so Vue can figure
                 out what to re-evaluate. */
              textDecoration: (highlightCommitment === commitmentConfig.$id) ? 'underline' : ''
            })"
            @click="onClickCommitment(commitmentConfig.$id)"
            @tap="onClickCommitment(commitmentConfig.$id)"
            ref="effort_text" />

          <v-text
            v-if="stageSettings.showAllProgress"
            :config="commitmentConfig.configStatus"
            ref="effort_status" />

          <!-- <portal to="visionboard-debug">GID: {{goal_id}} CID: {{commitmentConfig.$id}}: {{commitmentConfig}}</portal> -->
        </v-group>
      </template>
    </template>
    <template v-else>
      <v-circle :config="{
        radius: 100,
        fill:   'red',
        stroke: 'black',
        strokeWidth: 5
      }" />
    </template>

  </v-group>
</template>

<script>
import VIcon from './VIcon'
import CommitmentMixin from '@/components/Inline/CommitmentMixin'
import TilesFilter from './Filter'
import debounce from 'lodash.debounce';
import util from '@/util';
import DefaultImage from '@/assets/goal_placeholder.png'

const SAVE_GOAL_POSITION_THROTTLE_TIME = 1000;
const ENABLE_TILES_FILTER = false; /* This does not work on a tainted canvas! */
const ENABLE_DEV_CORS_PROXY = true;
// TODO: Set x,y for group
// TODO: Double tap = bring to front

export default {
  props: {
    goalId: {},
    goalSettings: {},
    stageSettings: {},
    isSelected: {},
    editable: {},
  },
  mixins: [CommitmentMixin],
  data: () => ({
    imageRaw: null, // TODO: nicht in data
    aspectRatio: 1.0,
    imageScaleTest: 1.0,
    highlightCommitment: null
  }),
  created() {
    this.loadImage();
  },
  mounted() {
    this.attachFilter();
  },
  watch: {
    publicGoalData: {
      handler: function(newValue) {
        this.loadImage();
        //this.attachFilter();
      },
      deep: true
    },
    isSelected(newValue) {
      /* testing */
      if (ENABLE_TILES_FILTER) {
        let nodeImg = this.$refs.image.getNode();
        nodeImg.draw()
        nodeImg.cache();
      }
    },
    goalSettings( newValue ) {
      let node = this.$refs.group.getNode()
      if ( newValue && node && Object.keys(node).length ) {
        //console.log("[VGoal] Settin Z-Index to", newValue.sortidx, newValue.cachedName );
        node.setZIndex( newValue.sortidx );
        node.drawHit();
        node.draw();
      } else {
        console.log("mounted but no node :(");
      }
    }
  },
  computed: {
    // ...mapGetters("goal", [
    //   "goal_list_state",
    //   "goal_by_id",
    //   "goal_list_ids",
    //   "goal_list_meta_ready_without_deleted",
    //   "goal_is_ready",
    // ]),

    publicGoalData() {
      return this.$models.goalMeta.subscribeNode( this.goalId );
    },

    isComplete() {
      // let publicGoal = this.publicGoalData;
      // let userGoal = this.goalSettings;
      //
      // console.log("publicGoal", publicGoal);
      // console.log("userGoal", userGoal);
      //
      // return publicGoal && userGoal;
      // return this.goal_is_ready( this.goal_id );
      return this.publicGoalData.$ready;
    },

    goalAddionalData() {
      let publicGoal = this.publicGoalData;

      /* When deleting publicGoal can become null while userGoal still exists.
         This is because the goal gets deleted before dettaching */
      if ( !publicGoal ) {
        return {
          visibility:     publicGoal.visibility, // "public",// private, friends only, accountability buddies only, on invitation only, with link only, public
          nrDoing:        publicGoal.goalStatistics.nrDoing, // 1100 people are doing this
          nrWishlist:     publicGoal.goalStatistics.nrWishlist, // 800 people have this goal on their wishlist
          nrWatching:     publicGoal.goalStatistics.nrWatching, // "accountabilityBuddies" - number of accountability buddies .. "10 People are watching you do this". they can leave likes, comments etc.
        }
      } else {
        return {};
      }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    goalConfig() {
      let userGoal = this.goalSettings; // this.goal_list_meta_ready_without_deleted[ this.goalId ];
      // console.log("userGoal", userGoal);

      // if ( !userGoal.graphicalRepresentation ) {
      //   // userGoal.graphicalRepresentation = {} // HACK ... create it
      //   return {
      //     showHeadline:     true,
      //     showImage:        true,
      //     showCommitments:  true,
      //     deadlines:        [],
      //   };
      // }

      // this is probably the user goal ... TODO: less data mapping
      return {
        // goalId: 1,
        // challengeId: 65634534534543, // Id of the parent challenge or goal .. referring to the template from the sidebar
        // showEdit: true,
        showHeadline:     userGoal['graphicalRepresentation.showHeadline'], // || true,
        showImage:        userGoal['graphicalRepresentation.showImage'], // || true,
        showCommitments:  userGoal['graphicalRepresentation.showCommitments'] , //|| true,
        deadlines:        userGoal.deadlineList || [], // "24.12.2018", // Vorher: Deadline ohne s
      };
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    groupConfig() {
      // TODO: just map

      let userGoal = this.goalSettings;

      // console.log("[VGoal] userGoal", userGoal);
      // console.log("[VGoal] userGoal.graphicalRepresentation", userGoal.graphicalRepresentation);

      if ( !userGoal ) {
        console.log("[VGoal] NO graphicalRepresentation for", userGoal)

        // This means the goal is probably from another user
        /* return {
          draggable:  this.editable, // true || this.isSelected, // oder true wenn's auch ohne Rahmen gehen soll
          x:          100,
          y:          100,
          rotation:   0,
          scaleX:     1,
          scaleY:     1,
        } */
      }

      return {
        draggable:  this.editable, // true || this.isSelected, // oder true wenn's auch ohne Rahmen gehen soll
        x:          userGoal['graphicalRepresentation.x'] || 100,
        y:          userGoal['graphicalRepresentation.y'] || 100,
        rotation:   userGoal['graphicalRepresentation.rotation'] || 0, // (Math.random() - 0.5) * 10,
        scaleX:     userGoal['graphicalRepresentation.scaleX'] || 1,
        scaleY:     userGoal['graphicalRepresentation.scaleY'] || 1,
        // zIndex: 2 // Important to put images above each other
      } // TODO: save this in obj
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    imageConfig() {
      let userGoal = this.goalSettings;
      let publicGoal = this.publicGoalData;

      // TODO: let image = new Konva.Image({
      let image = {
        // goalId: 1,
        // draggable: true, --> group
        image:         this.imageRaw,
        name:          userGoal.cachedName, // TODO: publicGoal.name ?
        src:           publicGoal ? publicGoal.picture : '', // TODO: immer in userGoal speichern?
        width:         this.imageScaleTest * 200 * this.aspectRatio, // userGoal.graphicalRepresentation.width,
        height:        this.imageScaleTest * 200, // userGoal.graphicalRepresentation.height,
        shadowColor:   userGoal['graphicalRepresentation.shadowColor'] || 'black',
        shadowBlur:    userGoal['graphicalRepresentation.shadowBlur'] || 10,
        shadowOffset:  {
          x: userGoal['graphicalRepresentation.shadowOffset.x'] || 10,
          y: userGoal['graphicalRepresentation.shadowOffset.y'] || 10
        },
        shadowOpacity: userGoal['graphicalRepresentation.shadowOpacity'] || 1,
        // scaleX: 1,
        // scaleY: 1
      };
      // TODO: Merge instead of typing
      return image;
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    headlineTextConfig() {
      let userGoal = this.goalSettings; // this.goal_list_meta_ready_without_deleted[ this.goalId ];
      /* let headline = Object.assign({ text: userGoal.cachedName, // text: "Have a nice physique", // fontFamily: "Roboto", // fontSize: 24, x: 200, y: 70, // draggable: true, fill: '#ffffff', scaleX: 1, scaleY: 1 }, userGoal.graphicalRepresentation.headline); */

      console.log("[VGoal] goalSettings", this.goalSettings)
      let scale = this.goalSettings['graphicalRepresentation.scaleX']

      /* fall back to allHeadlinesFontSize if not set */
      let fontSize = userGoal['graphicalRepresentation.headline.fontSize'] / scale ||
                     this.stageSettings.allHeadlinesFontSize / scale

      let yRelDistance = fontSize;

      let headline = Object.assign({}, {
        text:       userGoal.cachedName,
        fontSize:   fontSize,
        fontFamily: userGoal['graphicalRepresentation.headline.fontFamily'],
        offsetY:    yRelDistance, // Relative position
        align:      "left",
        fill:       '#ffffff',
      });
      // console.log("**** headline", headline);
      return headline;
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    commitmentConfigList() {
      // TODO: (optionally) only show my commitment
      // TODO: this gets triggerd way to often - MAYBE FIXED?
      // let publicGoal = this.publicGoalData;

      /*
      let commitment_list = this.$models
        .commitment
        .with({ goalId: this.goalId })
        .getList()
        .itemsAsArray();

      let commitment = $models.commitment
                       .with({ goalId: this.goalId })
                       .subscribeNode( commitment_meta.$id )

      let commmitment_user_settings = $models.userCommitmentSettings
                       .subscribeNode( commitment_meta.$id );

      let commitment_list = this.$models.commitment
        .with({ goalId: this.goalId })
        .getters
        .commitment_list_all
      */

      let commitment_meta_list = this.$models.commitmentMeta
        .with({ goalId: this.goalId })
        .getList()

      // if ( !publicGoalEfforts ) {
      //   return [];
      // }

      let i = 0;
      let commitmentConfigList = commitment_meta_list
        // .asArraySortedBy('startDate')(util.sorter.startDate)
        .itemsAsArray()
        .map(commitment_meta => {

        /*
        let commmitment_user_settings =
          this.$models.userCommitmentSettings
          .subscribeNode( commitment_meta.$id );
        */
        // this is optional!

        // if not exists
        // graphicalRepresentation

        let commitment =
          this.$models.commitment
          .with({ goalId: this.goalId })
          .subscribeNode( commitment_meta.$id )
        //   .getNodeFull( commitment_meta.$id )

        // console.log("[VGoal] commitmentConfigList",
        //   "commitment_meta", commitment_meta,
        //   "commmitment_user_settings", commmitment_user_settings,
        //   "commitment_details", commitment )

        let showCommitment = true;
        /*
        if ( !commmitment_user_settings || commmitment_user_settings.$state['.exists'] === false ) {
          commmitment_user_settings = {
            graphicalRepresentation: { show : true }
          }
          commmitment_user_settings.graphicalRepresentation.show
        }
        // TODO
        */

        let { status_color, status_text } =
          this.commitmentStatusColorAndText( commitment, commitment_meta )

        let commitmentStatusConfig = {
          text:       status_text,
          fontFamily: "Arial",
          fontSize:   this.defaultFontSize,
          offsetX:    this.defaultFontSize * 4, // this.stageSettings.allCommitmentsFontSize * 6 + 5,
          offsetY:    0,
          fill:       status_color,
          align:      "right",
          width:      this.defaultFontSize * 3
        };

        let commitmentTextConfig = {
          text: this.commitmentText( commitment, commitment_meta),
          // text: commitment.name,
          // commitmentId: commitment.commitmentId,
          // name: commitment.name, // commitmentId.toString(),
          // draggable: true,
          // goalId: goalId,
          fontFamily: "Arial",
          fontSize:   this.defaultFontSize,
          offsetX:    0,
          offsetY:    0,
          fill:        "#ffffff",
          align:      "left",
          scaleX:     1,
          scaleY:     1,
        };

        // TODO xPos, yPos
        if ( !commitment_meta.deleted ) {
          i = i + 1;
        }
        return {
          $id:            commitment_meta.$id,
          showCommitment: showCommitment,
          deleted:        commitment_meta.deleted, // TODO: in getter
          configText:     commitmentTextConfig,
          configStatus:   commitmentStatusConfig,
          startDate:      commitment.startDate,
          endDate:        commitment.endDate,
          group: {
            // TODO: offsetX, offsetY
            offsetX: 0,
            offsetY: -( this.imageConfig.height + this.defaultFontSize * ( i - 0.5) ), // xTODO: Bild höhe
          }
        };
      }).filter(item => {
         // Dont show deleted
        return !item.deleted;

      }).sort(util.sorter.startDate);

      // console.log("[VGoal] commitmentConfigList", commitmentConfigList)
      return commitmentConfigList
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    defaultFontSize() {
      let scale = this.goalSettings['graphicalRepresentation.scaleX'] || 1
      let fontSize = this.stageSettings.allCommitmentsFontSize / scale
      return fontSize
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    editIconPosition() {
      return {
        offsetX: -10 * (1 / 0.05),
        offsetY: (35 - this.imageScaleTest * 200) * (1 / 0.05),
        x: 10,
        y: this.imageScaleTest * 200 - 35,
      }
    },

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    /* editButtonIcon() {
      return {
        // x: this.editIcon.x,
        // y: this.editIcon.y,
        // TODO: Import from json
        data: 'M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z',
        fill: '#ffffff',
        stroke: '#000000',
        strokeWidth: 15,
        scale: { x: 0.05, y: 0.05 },
        offsetX: -10 * (1/0.05), // ( 35 - this.imageScaleTest * 200 * this.aspectRatio ) * (1/0.05),
        offsetY: ( 35 - this.imageScaleTest * 200 ) * (1/0.05),
        // draggable: false,
        // resize: false,
        // transform: false,
        hitFunc: function(context) { // has to be function (this)
          context.beginPath();
          context.arc(0, 0, 512 + 10, 0, Math.PI * 2, true);
          context.closePath();
          context.fillStrokeShape(this);
        }
      };
    }, */
  },
  methods: {
    loadImage() { // TODO: move to mixin or store "assets"
      let publicGoal = this.publicGoalData;

      if ( this.imageRaw ) {
        console.warn("[img] image already exists");
      }
      // if ( ENABLE_TILES_FILTER ) {}

      const image = new Image();

      image.crossOrigin = "anonymous";
      // image.crossOrigin = "use-credentials";

      image.onload = (imageEvent) => {
        // console.log("[img] onload", imageEvent, { url: publicGoal.picture });

        if ( 'width' in image ) {
          /* Info: this works in Firefox and Chrome */
          this.aspectRatio = image.width / image.height;
        } else {
          /* Info: this only works in Chrome */
          let imageMeta = imageEvent.path.pop();
          this.aspectRatio = imageMeta.width / imageMeta.height;
        }
        this.imageRaw = image;
      }

      image.onerror = (event) => {
        event.preventDefault();
        event.stopPropagation();
        console.log("[img] error loading image from",
          publicGoal.picture.substring(0, 30) + '...',
          { info: { url: publicGoal.picture, event } });
        //image.src = '';
        image.src = DefaultImage;
      }

      let prefix = ENABLE_DEV_CORS_PROXY ? 'https://cors-anywhere.herokuapp.com/' : ''
      image.src = prefix + publicGoal.picture;
      // console.log('[VGoal] image', image)

      // TODO: default image
    },

    attachFilter() {
      if (ENABLE_TILES_FILTER) {
        TilesFilter.init();
        setTimeout(() => {
          let node = this.$refs.image.getNode()
          node.filters([(img) => {
            return TilesFilter.filter(img, this.isSelected)
          }])
          node.cache();
          node.draw();
          // node.getLayer().draw();
        }, 1500 /* HACK */);
      }
    },

    onWheel(event) {
      let ENABLE_IMAGE_WHEEL_ZOOM = false;
      if ( ENABLE_IMAGE_WHEEL_ZOOM ) {
        this.imageScaleTest += event.evt.wheelDelta / 1000.0;
        event.evt.preventDefault();
      }
    },

    onTransform(event) {
      /*let positionData = {
        x: parseInt( event.currentTarget.attrs.x ),
        y: parseInt( event.currentTarget.attrs.y ),
        scaleX: ( event.currentTarget.attrs.scaleX ),
        scaleY: ( event.currentTarget.attrs.scaleY ),
        rotation: parseInt( event.currentTarget.attrs.rotation ),
      }*/

      let userGoal = this.goalSettings;
      let scale = event.currentTarget.attrs.scaleX
      let fontSizeHeadline = userGoal['graphicalRepresentation.headline.fontSize'] ||
                             this.stageSettings.allHeadlinesFontSize;
      fontSizeHeadline = fontSizeHeadline / scale;
      let fontSizeCommitment = this.stageSettings.allCommitmentsFontSize / scale

      /* Make sure we always get an array ($refs.effort_text won't be an array if there is only one) */
      let effortNodes       = [].concat(this.$refs.effort_text /*|| []*/).map(ref => ref.getNode());
      let effortStatusNodes = [].concat(this.$refs.effort_status /*|| []*/).map(ref => ref.getNode());
      let headlineNode      = this.$refs.headline.getNode();

      headlineNode.attrs.fontSize = fontSizeHeadline;
      headlineNode.attrs.offsetY  = fontSizeHeadline;
      headlineNode.textHeight     = fontSizeHeadline;

      effortNodes.forEach(node => {
        node.attrs.fontSize = fontSizeCommitment
        node.attrs.offsetX  = fontSizeCommitment * 4
        // node.attrs.textHeight = fontSizeCommitment
        // node.attrs.textHeight = -( this.imageConfig.height  + fontSizeCommitment * ( index - 1 - 0.5) )
      })

      effortStatusNodes.forEach(node => {
        node.attrs.fontSize = fontSizeCommitment
        // node.attrs.textHeight = fontSizeCommitment
        // node.attrs.offsetY = -( this.imageConfig.height  + fontSizeCommitment * ( index - 1 - 0.5) )
      });

      /* if ( headlineNode ) {
        headlineNode.attrs.y = fontSize
      } */
    },

    onUpdatePosition: debounce(function (event) {
      // let x  = event.currentTarget.attrs.x;
      // let y  = event.currentTarget.attrs.y;
      // let width = event.target.attrs.width;
      // let height = event.target.attrs.height;
      let positionData = {
        x: parseInt( event.target.attrs.x ),
        y: parseInt( event.target.attrs.y ),
        scaleX: ( event.target.attrs.scaleX ),  // NEU
        scaleY: ( event.target.attrs.scaleY ),  // NEU
        rotation: parseInt( event.target.attrs.rotation ),  // NEU
      }
      console.log("[VGoal] onUpdatePosition", positionData)

      const between = (min,v,max) => Math.max( min, Math.min(v, max) );
      // console.log("[VGoal] onUpdatePosition - before", positionData);

      positionData.scaleX = between(0.1, positionData.scaleX, 3.0);
      positionData.scaleY = between(0.1, positionData.scaleY, 3.0);
      positionData.x = between(0, positionData.x, this.stageSettings.width);
      positionData.y = between(0, positionData.y, this.stageSettings.height);

      // console.log(x,y,scaleX,scaleY,rotation);
      // console.log(event.target.attrs, event.currentTarget.attrs);
      // console.log("after2", positionData);

      if ( positionData.scaleX !== positionData.scaleY ) {
        console.log("I think aspect ratio should always stay the same, no?");
        positionData.scaleX = positionData.scaleY;
      }

      let payload = {}
      for ( let prop in positionData ) {
        payload['graphicalRepresentation/' + prop] = positionData[ prop ]
      }

      // TODO: implment selective update for subelements (merge option)
      // this.$api.update_user_goal({ data: { graphicalRepresentation }, goal_id: this.goalId });
      this.$models.userGoalSettings.update( this.goalId, payload );

    }, SAVE_GOAL_POSITION_THROTTLE_TIME),

    onDblClickImage(event) {
      // console.log("onDblClickImage");
      this.$emit('select', { type: 'image', goalId: this.goalId });
      // TODO: Update z-index / sortidx here
    },

    onClickCommitment(commitmentId) {
      console.log("onClickCommitment", commitmentId);

      this.$emit('select', {
        type:     'commitment',
        goalId:       this.goalId,
        commitmentId: commitmentId
      })
    },

    onClickGroup(event) {
      let node = this.$refs.group.getNode();

      // console.log("onClickGroup", this.transformerNode, this.$refs.group.getNode());
      this.$emit('select', { type: 'group', goalId: this.goalId, node: node });

      /*
      // ALTERNATIVE: Bubble event
      if ( this.transformerNode ) {
        // this.transformerNode.detach();
        this.transformerNode.attachTo( this.$refs.group.getNode() )
        // this.transformerNode.attachTo( this.$refs.image.getNode() )
        // this.transformerNode.parent.draw();
        // this.transformerNode.forceUpdate();
        this.transformerNode.parent.draw();
      }
      */
    },

    // handleStageMouseDown(event) {
    //   this.$emit('handleStageMouseDown', event);
    // },

    onMouseOver(event) {
      document.body.style.cursor = 'pointer';
    },

    onMouseOut(event) {
      document.body.style.cursor = 'default';
    },

    onMouseOverCommitment(event, commitmentId) {
      this.highlightCommitment = commitmentId;
    },

    onMouseOutCommitment(event, commitmentId) {
      // TODO: reihenfolge prüfen
      this.highlightCommitment = null;
    },

    editIconClick(event) {
      console.log("editIconClick");

      event.evt.preventDefault();
      event.evt.stopPropagation();

      this.$emit('edit-goal', { goalId: this.goalId, event });
      /*
      if (this.editIcon.type === 'goal') {
        this.showGoalUpdateForm(this.editIcon.$id);
      } else if (this.editIcon.type === 'commitment') {
        this.showCommitmentUpdateForm(this.editIcon.$id2,this.editIcon.$id);
      } else if (this.editIcon.type === 'text') {
        this.showTextUpdateForm(this.editIcon.$id);
      }
      */
    },

    addCommitmentIconClick(event) {
      console.log("addCommitmentIconClick");
      // this.add_commitment({ goal_id: this.goalId, name: 'Neues Commitment' });
      this.$emit('add-commitment', { goalId: this.goalId })
    },

  },
  components: {
    VIcon
  }
}
</script>
